import React, { useState, useEffect, useRef } from 'react';
import { portfolioData } from '../data/portfolioData';
import { sound } from './SoundSystem';

export default function CyberAssistant() {
  const [isOpen, setIsOpen] = useState(false);
  const [speech, setSpeech] = useState("Besoin d'un Lead Dev ? Scannez-moi !");
  const [copied, setCopied] = useState(false);
  const qrRef = useRef(null);

  const messages = [
    "Besoin d'un Lead Dev ? Scannez-moi !",
    "Projet web, mobile ou cloud ? Parlons-en !",
    "Appelez Babacar en 1 scan direct.",
    "Expert Java, Spring Boot & React à votre écoute !",
    "Disponible pour des missions stratégiques."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSpeech(messages[Math.floor(Math.random() * messages.length)]);
    }, 4500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isOpen && window.QRCode && qrRef.current) {
      qrRef.current.innerHTML = '';
      new window.QRCode(qrRef.current, {
        text: `tel:${portfolioData.personal.phone.replace(/\s+/g, '')}`,
        width: 140,
        height: 140,
        colorDark: "#00F59B",
        colorLight: "#0B132B",
        correctLevel: window.QRCode.CorrectLevel.H
      });
    }
  }, [isOpen]);

  const copyPhone = () => {
    sound.playClick();
    navigator.clipboard.writeText(portfolioData.personal.phone);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className={`cyber-assistant-root ${isOpen ? 'active' : ''}`}>
      {/* Speech Bubble */}
      {!isOpen && (
        <div className="assistant-bubble" onClick={() => setIsOpen(true)}>
          <span className="bubble-text">{speech}</span>
          <div className="bubble-arrow"></div>
        </div>
      )}

      {/* Floating 3D Bot Avatar */}
      <div 
        className="assistant-avatar"
        onClick={() => {
          sound.playClick();
          setIsOpen(!isOpen);
        }}
        title="Assistant Interactif & QR Code"
      >
        <div className="bot-head">
          <div className="bot-antenna">
            <span className="antenna-light"></span>
          </div>
          <div className="bot-eyes">
            <div className="bot-eye left"></div>
            <div className="bot-eye right"></div>
          </div>
          <div className="bot-mouth"></div>
        </div>
        <div className="bot-glow-ring"></div>
      </div>

      {/* QR Code & Contact Modal Popup */}
      {isOpen && (
        <div className="assistant-popup-card">
          <div className="popup-header">
            <div className="popup-title">
              <span className="prompt-sym">$</span>
              <span>scan_to_call.sh</span>
            </div>
            <button className="popup-close-btn" onClick={() => setIsOpen(false)}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div className="popup-body">
            <p className="popup-instruction">
              Scannez ce QR Code avec votre smartphone pour appeler directement Babacar Diagne.
            </p>

            <div className="qr-box-wrapper">
              <div ref={qrRef} className="qr-canvas-holder"></div>
              <div className="qr-corner-brackets"></div>
            </div>

            <div className="phone-display-row">
              <span className="phone-number">{portfolioData.personal.phone}</span>
              <button className="copy-btn" onClick={copyPhone} title="Copier le numéro">
                <i className={`fa-solid ${copied ? 'fa-check' : 'fa-copy'}`}></i>
                <span>{copied ? 'Copié !' : 'Copier'}</span>
              </button>
            </div>

            <div className="popup-action-buttons">
              <a 
                href={`tel:${portfolioData.personal.phone.replace(/\s+/g, '')}`}
                className="action-pill-btn call"
                onClick={() => sound.playClick()}
              >
                <i className="fa-solid fa-phone"></i>
                <span>Appeler</span>
              </a>

              <a 
                href={`https://wa.me/221773490318?text=${encodeURIComponent("Bonjour Babacar, j'ai visité votre portfolio et souhaite discuter d'un projet.")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="action-pill-btn whatsapp"
                onClick={() => sound.playClick()}
              >
                <i className="fa-brands fa-whatsapp"></i>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
